/* eslint-disable max-len */
// import { StateShape } from './reducers';
import { AppContextShape, defaultAnnotations, defaultAppContext } from './components/AppContext';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { types as coreTypes } from '@sitebuilder/core';
import { Annotator } from './annotations/annotator';

export const preloadedState = {
    app: {
        documentType: 'web',
        originalHostname: '',
        baseUrl: '/',
        url: '',
    },
    settings: {
        settings: null,
        settingsLoading: false,
        settingsLoadError: null,
        settingsSaveLoading: false,
        settingsSaveSucess: false,
        settingsSaveError: null,
    },
    templateEditor: {
        selectedId: '',
        data: {},
        document: {
            widgetInstances: {
                root: {
                    widgetId: 'document',
                    parentId: '',
                    id: 'root',
                    properties: {
                        styles: '',
                        dataSource: 'mutual-funds-production',
                        dataType: 'webProfile',
                        isWithinIFrame: true,
                        documentType: 'web',
                        pageTitleEn: '',
                        pageTitleFr: '',
                        loadingDataText: '',
                        fonts: [],
                        resourceStrings: [],
                        themes: [],
                        stickyHeaderClass: 'sticky-header',
                        favIconPath: '',
                        pdfPageSize: 'letter portrait',
                        pdfPageMargin: '0.4in',
                        iframeStickyHeaderType: 'Individual elements',
                        annotationsTextHtml: '',
                    },
                    contentPlaceHolders: {
                        children: [
                            '312fd5ab-0d25-46f5-8bfb-7a2692b316c0',
                            'faf99b9f-ce3e-4cd1-8770-53d7141ad1cd',
                            '64bf5bb9-4482-4273-baba-65dfff6c9f24',
                            '64bf5bb9-4482-4273-baba-65dfff6c9u24',
                            '64bf5bb9-4482-4273-baba-65dfff6c9u25',
                            '64bf5bb9-4482-4273-baba-65dfff6c9u26',
                            '93094ffc-7782-496f-bf09-288417ad6566',
                            '8c31537a-6403-497e-b6de-c75988aaf94d',
                            'f02802cf-345d-47de-a02d-cd73602d82ff',
                            '75fa479c-61f7-41bf-ac40-edf5c115cc66',
                            '711f764d-d3cc-40ff-ab89-3c7d22f2a094',
                            '3f4babc5-0069-44aa-b4a8-0350e3de2119',
                            '061fd219-614e-4184-8239-93d1f2d0ed1a',
                            'f7021ae0-5a2f-4ca7-9a82-08d99bfe6bfe',
                            '1be11f9d-4a0a-480f-bbee-eba6d0b7fc10',
                            '097c609f-9cdf-4213-aa92-31289da74d2c',
                            '677c609f-9cdf-4213-aa92-31289da74d2c',
                            '57m7df8f-9cdf-4213-aa92-31289da74d2c',
                            '942a54a5-bddf-41aa-853b-bf5cb2f89c14',
                            '802c3532-900d-4fc6-9e31-dbfd13f702cd',
                        ],
                    },
                },
                'faf99b9f-ce3e-4cd1-8770-53d7141ad1cd': {
                    id: 'faf99b9f-ce3e-4cd1-8770-53d7141ad1cd',
                    widgetId: 'DataProviderWebProfile',
                    parentId: 'root',
                    properties: {
                        dataSource: 'mutual-funds-production',
                        classnames: '',
                        expression: '{\n    children: webProfiles {\n      id\n    }\n}',
                        exports: [],
                    },
                    contentPlaceHolders: {
                        children: ['94a4134c-00ed-4d70-9312-0b94b61976fd'],
                    },
                },
                '94a4134c-00ed-4d70-9312-0b94b61976fd': {
                    id: '94a4134c-00ed-4d70-9312-0b94b61976fd',
                    widgetId: 'Section',
                    parentId: 'faf99b9f-ce3e-4cd1-8770-53d7141ad1cd',
                    properties: {
                        styles: 'position: sticky;\ntop: 0;\nz-index: 99;\ndisplay: none;',
                        id: 'minimized-header',
                        className: 'sticky-header',
                    },
                    contentPlaceHolders: {
                        children: ['ec293edd-5893-4360-8130-32688d1ea678'],
                    },
                },
                'ec293edd-5893-4360-8130-32688d1ea678': {
                    id: 'ec293edd-5893-4360-8130-32688d1ea678',
                    widgetId: 'TwoColumn',
                    parentId: '94a4134c-00ed-4d70-9312-0b94b61976fd',
                    properties: {
                        styles: '',
                        leftColumnOptions: {
                            width: '70%',
                            padding: '10px 10px 10px 35px',
                            border: 'none',
                        },
                        rightColumnOptions: {
                            width: '20%',
                            padding: '10px 20px 10px 10px',
                            border: 'none',
                        },
                        isTransformData: false,
                    },
                    contentPlaceHolders: {
                        leftColumn: ['ce6ebff5-014f-4349-8749-646db0113fa0'],
                        rightColumn: ['74cad3d8-faad-4287-a26e-490e90eb9b5f'],
                    },
                },
                'ce6ebff5-014f-4349-8749-646db0113fa0': {
                    id: 'ce6ebff5-014f-4349-8749-646db0113fa0',
                    widgetId: 'Text',
                    parentId: 'ec293edd-5893-4360-8130-32688d1ea678',
                    properties: {
                        styles: '',
                        textInput: '{{overview.fundName}}',
                        isTransformData: false,
                    },
                    contentPlaceHolders: {
                        children: [],
                    },
                },
                '74cad3d8-faad-4287-a26e-490e90eb9b5f': {
                    id: '74cad3d8-faad-4287-a26e-490e90eb9b5f',
                    widgetId: 'Table',
                    parentId: 'ec293edd-5893-4360-8130-32688d1ea678',
                    properties: {
                        styles: '',
                        columns: [],
                        transformRowsData: true,
                        isCollapsible: false,
                        functionToTransformRows: '',
                        rows: 'overview.fundCodes',
                    },
                    contentPlaceHolders: {
                        children: [],
                    },
                },
                '3e938947-93fc-4cbe-aa60-1b26700a9677': {
                    id: '3e938947-93fc-4cbe-aa60-1b26700a9677',
                    widgetId: 'ReferenceComponent',
                    parentId: 'root',
                    properties: {
                        referenceId: 'public/component-01',
                    },
                    customizations: {
                        '3e938947-93fc-4cbe-aa60-1b26700a9677/root': {
                            properties: {
                                styles: 'background: red;',
                            },
                        },
                    },
                    contentPlaceHolders: {
                        children: ['3e938947-93fc-4cbe-aa60-1b26700a9677/root'],
                    },
                    refLoaded: true,
                },
                '3e938947-93fc-4cbe-aa60-1b26700a9677/root': {
                    id: '3e938947-93fc-4cbe-aa60-1b26700a9677/root',
                    widgetId: 'Text',
                    parentId: '3e938947-93fc-4cbe-aa60-1b26700a9677',
                    properties: {
                        styles: 'background: white;',
                    },
                    contentPlaceHolders: {
                        children: [],
                    },
                    refId: '3e938947-93fc-4cbe-aa60-1b26700a9677',
                },
                '685f6ed2-9050-4032-a37c-538870cf4a3a': {
                    id: '685f6ed2-9050-4032-a37c-538870cf4a3a',
                    widgetId: 'FundCodesTable',
                    parentId: 'root',
                    properties: {
                        styles: '',
                        opacity: '',
                        blendMode: 'normal',
                        decoration: 'none',
                        fontFamily: '',
                        fontWeight: 'normal',
                        wordSpacing: '',
                        lineHeight: '',
                        textIndent: '',
                        color: '',
                        fontSize: '',
                        horizontalAlignment: '',
                        verticalAlignment: '',
                        shadow: '',
                        blendModeStyle: 'normal',
                        backgroundColor: '',
                        borderWidth: '',
                        borderColor: '',
                        borderStyle: 'unset',
                        borderRadius: '',
                        boxShadow: '',
                        margin: '',
                        padding: '',
                        display: '',
                        columns: [
                            {
                                hasChildColumns: false,
                                label: 'Fund Name',
                                value: '{{ name }}',
                            },
                            {
                                hasChildColumns: false,
                                label: 'MER',
                                value: '{{mer }}',
                            },
                            {
                                hasChildColumns: false,
                                label: 'Fees',
                                value: '{{ fundFeeRate }}',
                            },
                            {
                                hasChildColumns: true,
                                childColumns: [
                                    {
                                        label: 'BE',
                                        value: '{{ fundCodes.be }}',
                                    },
                                    {
                                        label: 'FE',
                                        value: '{{ fundCodes.fe }}',
                                    },
                                    {
                                        label: 'LL',
                                        value: '{{ fundCodes.ll }}',
                                    },
                                    {
                                        label: 'NL',
                                        value: '{{ fundCodes.nl }}',
                                    },
                                    {
                                        label: 'FCL',
                                        value: '{{ fundCodes.fcl }}',
                                    },
                                    {
                                        label: 'PSF',
                                        value: '{{ fundCodes.psf }}',
                                    },
                                ],
                                label: 'Fund codes',
                                value: '{{ fundCodes }}',
                            },
                            {
                                hasChildColumns: false,
                                label: 'Fund status',
                                value: '{{fundStatus}}',
                            },
                        ],
                        productGroup: {
                            dataKey: 'productGroups',
                            groupDataKey: 'name',
                            fundCodesDataKey: 'fundCodes',
                            fundDataKey: 'fundData',
                        },
                        transformRowsData: false,
                    },
                    contentPlaceHolders: {
                        children: [],
                    },
                },
                '64bf5bb9-4482-4273-baba-65dfff6c9f24': {
                    id: '64bf5bb9-4482-4273-baba-65dfff6c9f24',
                    widgetId: 'GrowthChart',
                    parentId: 'fa60660f-4f1e-4483-9bac-4565cca8fd38',
                    properties: {
                        styles: 'font-size: 0.8rem;\nmargin-top: 1rem;\n\n.date-picker-conatiner {\n  left: 24rem;\n}\n\n.start-date-container {\n  margin-right: 0.5rem !important;\n}\n\n.start-date-month-input, .end-date-month-input {\n  width: 4rem;\n}\n\n.total-returns {\n  left: 48rem;\n}\n\n.highcharts-data-labels{\n      transform: translate(55px, 96px);\n}\n\n@media only screen and (min-width: 320px) and (max-width: 769px) {\n  .date-picker-conatiner{\n    position: static !important;\n    left: none !important;\n    top: none !important;\n  }\n  \n  .total-returns{\n    position: static !important;\n    left: none !important;\n    top: none !important;\n  }\n}\n\n\n@media only screen and (min-width: 320px) and (max-width: 425px) {\n  div[data-highcharts-chart="0"] > div:first-of-type:before{\n    content: "Duration";\n    position: absolute;\n    top: 10px;\n    left: 45px;\n    font-size: 12px;\n    font-weight: bold;\n  }\n    font-size: 11px;\n}',
                        opacity: '',
                        blendMode: 'normal',
                        decoration: 'none',
                        fontFamily: '',
                        fontWeight: 'normal',
                        wordSpacing: '',
                        lineHeight: '',
                        textIndent: '',
                        color: '',
                        fontSize: '',
                        horizontalAlignment: '',
                        verticalAlignment: '',
                        shadow: '',
                        blendModeStyle: 'normal',
                        backgroundColor: '',
                        borderWidth: '',
                        borderColor: '',
                        borderStyle: 'unset',
                        borderRadius: '',
                        boxShadow: '',
                        margin: '',
                        padding: '',
                        display: '',
                        dataKey: 'performance.growth[*isCurrent=true]',
                        chartType: 'area',
                        showDateInput: true,
                        showInvestmentAmount: true,
                        showChartRange: true,
                        showTotalReturns: true,
                        showDifferentZone: true,
                        transformData: true,
                        options: [
                            {
                                path: 'plotOptions.area',
                            },
                            {
                                path: 'navigator',
                                value: '{"series": {"fillOpacity": 1}}',
                            },
                            {
                                path: 'plotOptions.series',
                            },
                            {
                                path: 'rangeSelector',
                                value: '{   "allButtonsEnabled": true }',
                            },
                        ],
                        rangeButtons:
                            '[   {     "count": 1,     "preserveDataGrouping": true,     "text": "1W",     "title": "View one week",     "type": "week"   },   {     "count": 1,     "preserveDataGrouping": true,     "text": "1M",     "title": "View one month",     "type": "month"   },   {     "preserveDataGrouping": true,     "text": "YTD",     "title": "View year to date",     "type": "ytd", "offsetMin": -86400000 },   {     "count": 1,     "preserveDataGrouping": true,     "text": "1Y",     "title": "View one year",     "type": "year"   },   {     "count": 5,     "preserveDataGrouping": true,     "text": "5Y",     "title": "View five years",     "type": "year"   },   {     "count": 10,     "preserveDataGrouping": true,     "text": "10Y",     "title": "View ten years",     "type": "year"   },   {     "preserveDataGrouping": true,     "text": "All",     "title": "View all",     "type": "all"   } ]',
                        datePickerOptions: {
                            startDateLabel: '{{resourceStrings.startDate}}',
                            endDateLabel: '{{resourceStrings.endDate}}',
                            startDayAriaLabel: '{{ resourceStrings.startDay }}',
                            startMonthAriaLabel: '{{ resourceStrings.startMonth }}',
                            startYearAriaLabel: '{{ resourceStrings.startYear }}',
                            endDayAriaLabel: '{{ resourceStrings.endDay }}',
                            endMonthAriaLabel: '{{ resourceStrings.endMonth }}',
                            endYearAriaLabel: '{{ resourceStrings.endYear }}',
                        },
                        toolTipValueFormat: 'curMax2',
                        toolTipDateFormat: 'dateMed',
                        isLimitToTenYears: false,
                        growthAmountLabel: '{{resourceStrings.investmentAmount}}:',
                        initialGrowthAmount: 10000,
                        totalReturnsLabel: '{{resourceStrings.totalReturn}}',
                        zoneOptions: {
                            year: '{{ overview.inceptionDate }}',
                        },
                        functionToTransform:
                            "return (data) => { \nconst growthChartData = data.growthChartData;\nconst underlyingFundPath= 'overview.underlyingFund.growth';  \nconst underlyingGrowth = data.JsonQuery(`${underlyingFundPath}`, { data: data.data }).value;\n\nconst rebaseChartData = (newInput, preparedData, nextPoint) => {\n    const diff = newInput / nextPoint.value;\n    const mappedData = [];\n    preparedData.forEach(function (point) {\n        mappedData.push({ date: point.date, value: point.value * diff })\n    });\n    return mappedData;\n}\n\nif (underlyingGrowth?.length > 0) {\nconst underlyingData = underlyingGrowth?.filter(d => new Date(d.date) < new Date(data.data?.overview?.inceptionDate));\n            let values = growthChartData[0].values;\n            values.map((v) => {\n                const underlyingValue = underlyingData.find((d) => new Date(d.date) === new Date(v.date));\n                if (underlyingValue) {\n                    return underlyingValue;\n                }\n                return v;\n            });\n\n            \n    values = rebaseChartData(underlyingData[underlyingData.length -1].value, values, values[0]);\n\n            growthChartData[0] = {\n                ...growthChartData[0],\n                values: [...underlyingData, ...values],\n            };\n        }\n\n  return { ...data, growthChartData }\n}",
                        chartTitle: 'Fund: $9,867.30 at Dec 12, 2018',
                        noDataMessage: 'Chart has no data',
                    },
                    contentPlaceHolders: {
                        children: [],
                    },
                },
                '64bf5bb9-4482-4273-baba-65dfff6c9u24': {
                    id: '64bf5bb9-4482-4273-baba-65dfff6c9u24',
                    widgetId: 'EquityBox',
                    parentId: 'fa60660f-4f1e-4483-9bac-4565cca8fd38',
                    properties: {
                        borderColor: '',
                        borderStyle: 'unset',
                        isMultipleDownload: true,
                        showHeader: true,
                        downloadAllButtonOption: {
                            buttonName: 'test',
                            showIcon: false,
                            iconType: '',
                            iconName: '',
                            iconURL: '',
                            iconPosition: 'Right',
                        },
                    },
                    contentPlaceHolders: {
                        children: [],
                    },
                },
                '64bf5bb9-4482-4273-baba-65dfff6c9u25': {
                    id: '64bf5bb9-4482-4273-baba-65dfff6c9u25',
                    widgetId: 'SubSections',
                    parentId: 'fa60660f-4f1e-4483-9bac-4565cca8fd38',
                    properties: {
                        borderColor: '',
                        borderStyle: 'unset',
                        subSectionsList: [
                            {
                                label: 'Overview',
                                addToggleLabels: false,
                                defaultToggleSection: '',
                                toggleSectionsList: [],
                            },
                            {
                                label: 'Performance',
                                addToggleLabels: false,
                                defaultToggleSection: '',
                                toggleSectionsList: [],
                            },
                        ],
                        defaultActiveSubSection: 1,
                        isRenderAsTabs: true,
                    },
                    contentPlaceHolders: {
                        children: [],
                    },
                },
                '64bf5bb9-4482-4273-baba-65dfff6c9u26': {
                    id: '64bf5bb9-4482-4273-baba-65dfff6c9u26',
                    widgetId: 'ExpandCollapseSections',
                    parentId: 'fa60660f-4f1e-4483-9bac-4565cca8fd38',
                    properties: {
                        borderColor: '',
                        borderStyle: 'unset',
                        sectionsList: [
                            {
                                title: 'Section 1',
                                content: 'Section 1 Content',
                                isPlaceHolder: false,
                                uniqueSectionId: 'Section-1',
                            },
                            {
                                title: 'Section 2',
                                content: 'Section 2 Content',
                                isPlaceHolder: false,
                                uniqueSectionId: 'Section-2',
                            },
                        ],
                        iconsType: 'FontAwesome',
                        defaultActiveSubSection: 1,
                        isTransformData: false,
                    },
                    contentPlaceHolders: {
                        children: [],
                    },
                },
                '93094ffc-7782-496f-bf09-288417ad6566': {
                    id: '93094ffc-7782-496f-bf09-288417ad6566',
                    widgetId: 'StockChart',
                    parentId: 'root',
                    properties: {
                        styles: '',
                        opacity: '',
                        blendMode: 'normal',
                        decoration: 'none',
                        fontFamily: '',
                        fontWeight: 'normal',
                        wordSpacing: '',
                        lineHeight: '',
                        textIndent: '',
                        color: '',
                        fontSize: '',
                        horizontalAlignment: '',
                        verticalAlignment: '',
                        shadow: '',
                        blendModeStyle: 'normal',
                        backgroundColor: '',
                        borderWidth: '',
                        borderColor: '',
                        borderStyle: 'unset',
                        borderRadius: '',
                        boxShadow: '',
                        margin: '',
                        padding: '',
                        display: '',
                        dataKey: 'performance.growth',
                        xyKeys: 'date,value',
                        showDistributions: false,
                        showGrowthAmount: true,
                        chartTitles: [],
                        chartType: 'area',
                        legendDropDownTitle: 'Compare benchmark:',
                        rangeButtons: '',
                        toolTipValueFormat: 'cur',
                        dollarChangeValueFormat: 'curDiffMax4',
                        options: [],
                        isShowBenchMarks: true,
                        isGrowthChart: true,
                        growthAmountLabel: 'Investment amount ($):',
                        initialGrowthAmount: 10000,
                        distributionKey: 'distributionAmount',
                        addOffsetMinToYtd: true,
                    },
                    contentPlaceHolders: { children: [] },
                },
                '8c31537a-6403-497e-b6de-c75988aaf94d': {
                    id: '8c31537a-6403-497e-b6de-c75988aaf94d',
                    widgetId: 'GeographicAllocationMap',
                    parentId: 'root',
                    properties: {
                        styles: '',
                        opacity: '',
                        blendMode: 'normal',
                        decoration: 'none',
                        fontFamily: '',
                        fontWeight: 'normal',
                        wordSpacing: '',
                        lineHeight: '',
                        textIndent: '',
                        color: '',
                        fontSize: '',
                        horizontalAlignment: '',
                        verticalAlignment: '',
                        shadow: '',
                        blendModeStyle: 'normal',
                        backgroundColor: '',
                        borderWidth: '',
                        borderColor: '',
                        borderStyle: 'unset',
                        borderRadius: '',
                        boxShadow: '',
                        margin: '',
                        padding: '',
                        display: '',
                        dataKey: 'allocations',
                        dataLimit: 10,
                        countryNameKey: 'holding',
                        countryValueKey: 'allocation',
                        countryCodeKey: 'country.entityId',
                        colors: '',
                        showOtherRegions: true,
                    },
                    contentPlaceHolders: {},
                },
                'f02802cf-345d-47de-a02d-cd73602d82ff': {
                    id: 'f02802cf-345d-47de-a02d-cd73602d82ff',
                    widgetId: 'Modal',
                    parentId: 'root',
                    properties: {
                        openButtonHtml: '<span>Open</span>',
                        closeButtonHtml: '<span>Close</span>',
                        showModalInEditMode: false,
                        isWithinIframe: true,
                        isShowPrintButton: true,
                        printButtonHtml: 'PRINT',
                    },
                    contentPlaceHolders: { modal: [] },
                },
                '75fa479c-61f7-41bf-ac40-edf5c115cc66': {
                    id: '75fa479c-61f7-41bf-ac40-edf5c115cc66',
                    widgetId: 'FundList',
                    parentId: 'root',
                    properties: {
                        styles: '',
                        iconShowContent: 'fas fa-plus-circle',
                        iconHideContent: 'fas fa-minus-circle',
                        firstColumnOptions: {
                            type: 'favorites',
                            storageName: 'favorites-mutual',
                            iconType: 'Font-awesome',
                            addIconName: 'far fa-star',
                            removeIconName: 'fas fa-star',
                            addIconURL: '',
                            removeIconURL: '',
                            id: 'entityId',
                            jsonPath: 'entityId',
                        },
                        hideTabHeader: true,
                        views: [
                            {
                                columns: [
                                    {
                                        disableSorting: false,
                                        transformFunction: 'return (data) => { return data }',
                                        hideColumn: false,
                                        excelOptions: { showColumn: true },
                                        id: 'fundName',
                                        label: '{{resourceStrings.fundName}}',
                                        jsonPath: 'overview.fundName',
                                    },
                                    {
                                        disableSorting: false,
                                        transformFunction: 'return (data) => { return data }',
                                        hideColumn: false,
                                        excelOptions: { showColumn: true },
                                        id: 'seriesShortName',
                                        label: '{{resourceStrings.series}}',
                                        jsonPath: 'overview.seriesShortName',
                                    },
                                    {
                                        disableSorting: false,
                                        transformFunction: 'return (data) => { return data }',
                                        hideColumn: false,
                                        excelOptions: {
                                            showColumn: true,
                                            excelLabel: '{{{resourceStrings.currency}}}',
                                        },
                                        label: '{{resourceStrings.CUR}}',
                                        id: 'currency',
                                        jsonPath: 'overview.currency',
                                    },
                                    {
                                        disableSorting: false,
                                        transformFunction: 'return (data) => { return data }',
                                        hideColumn: false,
                                        excelOptions: {
                                            showColumn: true,
                                            excelLabel: '{{{resourceStrings.fundAssetsExcel}}}',
                                        },
                                        label: '{{resourceStrings.fundAssets}}',
                                        id: 'aum',
                                        jsonPath: 'overview.aum',
                                        format: 'currLong1',
                                    },
                                    {
                                        disableSorting: false,
                                        transformFunction: 'return (data) => { return data }',
                                        hideColumn: false,
                                        excelOptions: {
                                            showColumn: true,
                                            excelLabel: '{{{resourceStrings.merExcel}}}',
                                        },
                                        id: 'mer',
                                        label: '{{resourceStrings.MER}}',
                                        jsonPath: 'overview.mer',
                                        format: 'pctMax2',
                                        nullGuard: '{{ resourceStrings.nullGuard }}',
                                        noDataAnnotationId: 'merValue',
                                    },
                                    {
                                        disableSorting: false,
                                        transformFunction: 'return (data) => { return data }',
                                        hideColumn: false,
                                        excelOptions: { showColumn: true, dataKey: 'name' },
                                        id: 'riskRating',
                                        label: '{{resourceStrings.riskRating}}',
                                        jsonPath: 'overview.riskRating',
                                        columnType: 'risk',
                                    },
                                ],
                                id: 'overview',
                                label: '{{resourceStrings.overview}}',
                            },
                            {
                                columns: [
                                    {
                                        disableSorting: false,
                                        transformFunction: 'return (data) => { return data }',
                                        hideColumn: false,
                                        excelOptions: { showColumn: true },
                                        id: 'fundName',
                                        label: '{{resourceStrings.fundName}}',
                                        jsonPath: 'overview.fundName',
                                    },
                                ],
                                id: 'Daily Prices',
                                label: '{{resourceStrings.overview}}',
                            },
                        ],
                        hideAllFilters: false,
                        filters: [
                            {
                                id: 'currency',
                                label: '{{resourceStrings.currency}}',
                                jsonPath: 'overview.currency',
                                matchesFrom: 'value',
                                defaultValue: '{{resourceStrings.currencyFilterDefaultValue}}',
                            },
                        ],
                        grouping: {
                            enabled: false,
                            propertyId: 'assetClass',
                            jsonPath: 'overview.assetClass',
                        },
                        fundUrl: '/test-fund-url/{{entityId}}',
                        fundUrlBase: '/test-fund-base-url',
                        fundPdfUrlBase: '/',
                        fundUrlMapping: [
                            {
                                parameters: [
                                    { key: 'mode', value: 'public' },
                                    { key: 'env', value: 'sit' },
                                ],
                                fundUrlTag: 'fp-public-sit',
                            },
                            {
                                parameters: [
                                    { key: 'mode', value: 'public' },
                                    { key: 'env', value: 'stage' },
                                ],
                                fundUrlTag: 'fp-public-staging',
                            },
                            {
                                parameters: [
                                    { key: 'mode', value: 'public' },
                                    { key: 'env', value: 'prod' },
                                ],
                                fundUrlTag: 'fp-public-prod',
                            },
                            {
                                parameters: [
                                    { key: 'mode', value: 'secure' },
                                    { key: 'env', value: 'sit' },
                                ],
                                fundUrlTag: 'fp-secure-sit',
                            },
                            {
                                parameters: [
                                    { key: 'mode', value: 'secure' },
                                    { key: 'env', value: 'stage' },
                                ],
                                fundUrlTag: 'fp-secure-staging',
                            },
                            {
                                parameters: [
                                    { key: 'mode', value: 'secure' },
                                    { key: 'env', value: 'prod' },
                                ],
                                fundUrlTag: 'fp-secure-prod',
                            },
                        ],
                        constantDataPoints: [{ key: 'prefix', value: 'SUN' }],
                        downloadFileOptions: {
                            excelTabs: [
                                {
                                    disclaimers: [
                                        {
                                            filters: {},
                                            showMarker: true,
                                            filterBy: '{"__inUse" : true}',
                                        },
                                        {
                                            filters: {},
                                            showMarker: false,
                                            filterBy: '{ "_id": "pnpDailyPricesCorpClass"}',
                                        },
                                        {
                                            filters: {},
                                            showMarker: false,
                                            filterBy: '{ "_id": "pnpPerformanceCommissions"}',
                                        },
                                        {
                                            filters: {},
                                            showMarker: false,
                                            filterBy: '{ "_id": "pnpRatingsCommissions"}',
                                        },
                                    ],
                                    showDisclaimer: true,
                                },
                            ],
                            fileType: '.xlsx',
                        },
                        transformFunction:
                            "return (data) => { \n  let processedData = data.data;\n  let locale = data?.locale\n  let filters = data.filters;\n\n  const nullGuard = data?.locale == 'en-US' ? 'N/A': 'N.D';\n  processedData = processedData?.map(data => {\n    let d;\n    let v;\n  \n    if(data?.entityId?.includes('-USD')){\n      d = { ...data, entityId: data.entityId.replace('-USD', '-CAD')}\n    }else {\n     d = data\n    }\n   \n     if(d.mer){\n       v = d\n     }else if(!d['1yr']){\n       v = d \n     }else{\n       v = {...d, mer: nullGuard }\n     }\n      return {locale , ...v};\n  });\n\n  if (data.currentViewId === 'performance') {\n    processedData= processedData?.filter(data => data.currency !== 'USD'); \n    \n    filters?.forEach(f => {\n      if (f.id === \"currency\") {\n        f.values= f.values.filter(v => v.value !== 'USD')\n      }\n    });\n  }\n\n  return { ...data, data: processedData, filters }\n}",
                        fundUrls: [
                            {
                                parameters: [
                                    { key: 'mode', value: 'public' },
                                    { key: 'env', value: 'sit' },
                                ],
                                fundUrlBase: '/',
                            },
                            {
                                parameters: [
                                    { key: 'mode', value: 'public' },
                                    { key: 'env', value: 'stage' },
                                ],
                                fundUrlBase: '/',
                            },
                            {
                                parameters: [
                                    { key: 'mode', value: 'public' },
                                    { key: 'env', value: 'prod' },
                                ],
                                fundUrlBase: '/',
                            },
                            {
                                parameters: [
                                    { key: 'mode', value: 'secure' },
                                    { key: 'env', value: 'sit' },
                                ],
                                fundUrlBase: '/',
                            },
                            {
                                parameters: [
                                    { key: 'mode', value: 'secure' },
                                    { key: 'env', value: 'stage' },
                                ],
                                fundUrlBase: '/',
                            },
                            {
                                parameters: [
                                    { key: 'mode', value: 'secure' },
                                    { key: 'env', value: 'prod' },
                                ],
                                fundUrlBase: '/',
                            },
                        ],
                        useIconForFavoriteColumn: 'th-icon fas fa-star',
                        favoriteColumnTooltipBgColor: '#012C3D',
                        favoriteColumnTooltipTextColor: '#fff',
                    },
                    contentPlaceHolders: { children: [] },
                },
                '35fa479c-61f7-41bf-ac40-edf5c115cc66': {
                    id: '75fa479c-61f7-41bf-ac40-edf5c115cc66',
                    widgetId: 'FundList',
                    parentId: 'root',
                    properties: {
                        styles: '',
                        iconShowContent: 'fas fa-plus-circle',
                        iconHideContent: 'fas fa-minus-circle',
                        firstColumnOptions: {
                            type: 'favorites',
                            storageName: 'favorites-mutual',
                            iconType: 'Font-awesome',
                            addIconName: 'far fa-star',
                            removeIconName: 'fas fa-star',
                            addIconURL: '',
                            removeIconURL: '',
                            id: 'entityId',
                            jsonPath: 'entityId',
                        },
                        addPlaceholderAfterFilters: true,
                        isShowClearSelectionButton: true,
                        isShowCopyButton: true,
                        isShowEmailButton: true,
                        hideTabHeader: true,
                        views: [
                            {
                                columns: [
                                    {
                                        disableSorting: false,
                                        transformFunction: 'return (data) => { return data }',
                                        hideColumn: false,
                                        excelOptions: { showColumn: true },
                                        id: 'fundName',
                                        label: '{{resourceStrings.fundName}}',
                                        jsonPath: 'overview.fundName',
                                    },
                                    {
                                        disableSorting: true,
                                        transformFunction: 'return (data) => { return data }',
                                        hideColumn: false,
                                        excelOptions: { showColumn: true },
                                        id: 'Selected List',
                                        label: 'Selected Funds',
                                        jsonPath: 'overview.fundName',
                                        columnType: 'checklist',
                                    },
                                ],
                                id: 'overview',
                                label: '{{resourceStrings.overview}}',
                            },
                        ],
                        hideAllFilters: true,
                        filters: [
                            {
                                id: 'currency',
                                label: '{{resourceStrings.currency}}',
                                jsonPath: 'overview.currency',
                                matchesFrom: 'value',
                                defaultValue: '{{resourceStrings.currencyFilterDefaultValue}}',
                            },
                        ],
                        grouping: {
                            enabled: false,
                            propertyId: 'assetClass',
                            jsonPath: 'overview.assetClass',
                        },
                        fundUrlBase: '',
                        fundPdfUrlBase: '/',
                        fundUrlMapping: [
                            {
                                parameters: [
                                    { key: 'mode', value: 'public' },
                                    { key: 'env', value: 'sit' },
                                ],
                                fundUrlTag: 'fp-public-sit',
                            },
                            {
                                parameters: [
                                    { key: 'mode', value: 'public' },
                                    { key: 'env', value: 'stage' },
                                ],
                                fundUrlTag: 'fp-public-staging',
                            },
                            {
                                parameters: [
                                    { key: 'mode', value: 'public' },
                                    { key: 'env', value: 'prod' },
                                ],
                                fundUrlTag: 'fp-public-prod',
                            },
                            {
                                parameters: [
                                    { key: 'mode', value: 'secure' },
                                    { key: 'env', value: 'sit' },
                                ],
                                fundUrlTag: 'fp-secure-sit',
                            },
                            {
                                parameters: [
                                    { key: 'mode', value: 'secure' },
                                    { key: 'env', value: 'stage' },
                                ],
                                fundUrlTag: 'fp-secure-staging',
                            },
                            {
                                parameters: [
                                    { key: 'mode', value: 'secure' },
                                    { key: 'env', value: 'prod' },
                                ],
                                fundUrlTag: 'fp-secure-prod',
                            },
                        ],
                        constantDataPoints: [{ key: 'prefix', value: 'SUN' }],
                        downloadFileOptions: {
                            excelTabs: [
                                {
                                    disclaimers: [
                                        {
                                            filters: {},
                                            showMarker: true,
                                            filterBy: '{"__inUse" : true}',
                                        },
                                        {
                                            filters: {},
                                            showMarker: false,
                                            filterBy: '{ "_id": "pnpDailyPricesCorpClass"}',
                                        },
                                        {
                                            filters: {},
                                            showMarker: false,
                                            filterBy: '{ "_id": "pnpPerformanceCommissions"}',
                                        },
                                        {
                                            filters: {},
                                            showMarker: false,
                                            filterBy: '{ "_id": "pnpRatingsCommissions"}',
                                        },
                                    ],
                                    showDisclaimer: true,
                                },
                            ],
                            fileType: '.xlsx',
                        },
                        transformFunction:
                            "return (data) => { \n  let processedData = data.data;\n  let locale = data?.locale\n  let filters = data.filters;\n\n  const nullGuard = data?.locale == 'en-US' ? 'N/A': 'N.D';\n  processedData = processedData?.map(data => {\n    let d;\n    let v;\n  \n    if(data?.entityId?.includes('-USD')){\n      d = { ...data, entityId: data.entityId.replace('-USD', '-CAD')}\n    }else {\n     d = data\n    }\n   \n     if(d.mer){\n       v = d\n     }else if(!d['1yr']){\n       v = d \n     }else{\n       v = {...d, mer: nullGuard }\n     }\n      return {locale , ...v};\n  });\n\n  if (data.currentViewId === 'performance') {\n    processedData= processedData?.filter(data => data.currency !== 'USD'); \n    \n    filters?.forEach(f => {\n      if (f.id === \"currency\") {\n        f.values= f.values.filter(v => v.value !== 'USD')\n      }\n    });\n  }\n\n  return { ...data, data: processedData, filters }\n}",
                        fundUrls: [
                            {
                                parameters: [
                                    { key: 'mode', value: 'public' },
                                    { key: 'env', value: 'sit' },
                                ],
                                fundUrlBase: '/',
                            },
                        ],
                        useIconForFavoriteColumn: 'th-icon fas fa-star',
                        favoriteColumnTooltipBgColor: '#012C3D',
                        favoriteColumnTooltipTextColor: '#fff',
                    },
                    contentPlaceHolders: { children: [] },
                },
                'f7021ae0-5a2f-4ca7-9a82-08d99bfe6bfe': {
                    id: 'f7021ae0-5a2f-4ca7-9a82-08d99bfe6bfe',
                    widgetId: 'ManagersContainer',
                    parentId: 'root',
                    properties: {
                        styles: '.text-widget { border-bottom: 1px solid #ccc; margin: 2%; font-size: 1.6em; }\n}\n  \n\n h2 {\n  border-bottom: 1px solid black;\n  margin: 2%; \n  font-size: 1.6em;\n}\n\n.company:first-child{\n  margin-top: 20px;\n}\n\n.companyDetails{\n  width: 70%;\n  justify-content: start !important;\n}\n\n.companyDesc{\n  width: 100% !important;\n}\n\n.link{\n  color: var(--color-primary) !important;\n  text-decoration: none;\n  font-weight: bold;\n  padding: 2%;\n  display: inline-block;\n  font-size: 1.1em !important;\n\n.link-name { \n    color: #002D3D !important;\n  }\n\n.link-name:hover{\n    text-decoration: underline;  \n  }\n}\nh3 {\n  border-bottom: 1px solid #ccc !important;\n   margin: 2% !important;\n  font-size: 1.6em;\n  font-weight: 400;\n}\n\n.without-image {\n  margin-top: 0px !important;\n  .companyDetails {\n    width: 100%;\n    margin-top: 0px;\n  }\n}\n\n.company {\n  align-items: center;\n  \n  .companyImg {\n    height: auto !important;\n    align-self: flex-start;\n  }\n}',
                        containerTitles: [
                            {
                                headingLevel: 3,
                                headerText: '{{ resourceStrings.subAdvisors}}',
                                markerLabel: '',
                            },
                        ],
                        dataKey: 'managers',
                        isCompany: false,
                        inNewTab: true,
                        linkIcon: 'fas fa-arrow-circle-right',
                        isImgLink: true,
                        managerBioHtml: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia,
                        molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum
                        numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium
                        optio, eaque rerum! Provident similique accusantium nemo autem. Veritatis`,
                        managerBio: `{{biography}}`,
                        managerNameHtml: 'Tim Cook',
                        localeSupport: true,
                        teamLink: ' ',
                        useAnalytics: true,
                        isBioReadMore: true,
                        altText: '',
                        imageLink: '/assets/static/images',
                        linkTarget: '_parent',
                        dynamicEvents: [
                            {
                                eventName: 'Read Bio',
                                analyticItems: [{ name: 'Read Bio', value: '{{managerName}}' }],
                            },
                        ],
                    },
                    contentPlaceHolders: {
                        children: [],
                    },
                },
                '312fd5ab-0d25-46f5-8bfb-7a2692b316c0': {
                    id: '312fd5ab-0d25-46f5-8bfb-7a2692b316c0',
                    widgetId: 'Link',
                    parentId: 'root',
                    properties: {
                        styles: '',
                        opacity: '',
                        blendMode: 'normal',
                        decoration: 'none',
                        fontFamily: '',
                        fontWeight: 'normal',
                        wordSpacing: '',
                        lineHeight: '',
                        textIndent: '',
                        color: '',
                        fontSize: '',
                        horizontalAlignment: '',
                        verticalAlignment: '',
                        shadow: '',
                        blendModeStyle: 'normal',
                        backgroundColor: '',
                        borderWidth: '',
                        borderColor: '',
                        borderStyle: 'unset',
                        borderRadius: '',
                        boxShadow: '',
                        margin: '',
                        padding: '',
                        display: '',
                        navigateWithinPage: true,
                        linkClassName: 'nav-link',
                        showIcon: false,
                        openInNewTab: false,
                        linkName: 'link',
                        link: '',
                        isWithinIframe: true,
                        linkHref: 'nav-section',
                    },
                    contentPlaceHolders: {
                        children: [],
                    },
                },
                '711f764d-d3cc-40ff-ab89-3c7d22f2a094': {
                    id: '711f764d-d3cc-40ff-ab89-3c7d22f2a094',
                    widgetId: 'Section',
                    parentId: 'root',
                    properties: {
                        styles: '',
                        opacity: '',
                        blendMode: 'normal',
                        decoration: 'none',
                        fontFamily: '',
                        fontWeight: 'normal',
                        wordSpacing: '',
                        lineHeight: '',
                        textIndent: '',
                        color: '',
                        fontSize: '',
                        horizontalAlignment: '',
                        verticalAlignment: '',
                        shadow: '',
                        blendModeStyle: 'normal',
                        backgroundColor: '',
                        borderWidth: '',
                        borderColor: '',
                        borderStyle: 'unset',
                        borderRadius: '',
                        boxShadow: '',
                        margin: '',
                        padding: '',
                        display: '',
                        id: 'nav-section',
                    },
                    contentPlaceHolders: {
                        children: ['63346758-f3e9-4b52-88f6-dcc7e8f7defa'],
                    },
                },
                '3f4babc5-0069-44aa-b4a8-0350e3de2119': {
                    id: '3f4babc5-0069-44aa-b4a8-0350e3de2119',
                    widgetId: 'Table',
                    parentId: 'root',
                    properties: {
                        styles: '',
                        opacity: '',
                        blendMode: 'normal',
                        decoration: 'none',
                        fontFamily: '',
                        fontWeight: 'normal',
                        wordSpacing: '',
                        lineHeight: '',
                        textIndent: '',
                        color: '',
                        fontSize: '',
                        horizontalAlignment: '',
                        verticalAlignment: '',
                        shadow: '',
                        blendModeStyle: 'normal',
                        backgroundColor: '',
                        borderWidth: '',
                        borderColor: '',
                        borderStyle: 'unset',
                        borderRadius: '',
                        boxShadow: '',
                        margin: '',
                        padding: '',
                        display: '',
                        columns: [
                            { label: 'Name', value: '{{ overview.fundName }}' },
                            {
                                linkText: '{{ webProfiles.relatedDocuments.0.name }}',
                                label: 'Document',
                                value: '{{ relatedDocuments.0.name}}',
                                isLink: true,
                                linkIcon: 'fas fa-file-pdf',
                                linkUrl: '{{ relatedDocuments.0.url}}',
                            },
                        ],
                        transformRowsData: false,
                        isCollapsible: false,
                        filterData: false,
                        rows: 'webProfiles',
                    },
                    contentPlaceHolders: { children: [] },
                },
                '942a54a5-bddf-41aa-853b-bf5cb2f89c14': {
                    id: '942a54a5-bddf-41aa-853b-bf5cb2f89c14',
                    widgetId: 'Table',
                    parentId: 'root',
                    properties: {
                        styles: '.table-container {\r\n    height: 10rem;\r\n    overflow: scroll;\r\n}',
                        opacity: '',
                        blendMode: 'normal',
                        decoration: 'none',
                        fontFamily: '',
                        fontWeight: 'normal',
                        wordSpacing: '',
                        lineHeight: '',
                        textIndent: '',
                        color: '',
                        fontSize: '',
                        horizontalAlignment: '',
                        verticalAlignment: '',
                        shadow: '',
                        typographyClass: 'Default',
                        blendModeStyle: 'normal',
                        backgroundColor: '',
                        borderWidth: '',
                        borderColor: '',
                        borderStyle: 'unset',
                        borderRadius: '',
                        boxShadow: '',
                        width: '',
                        height: '',
                        margin: '',
                        padding: '',
                        display: '',
                        columns: [
                            {
                                label: 'EffectiveDate',
                                value: '{{formatUniversalDate effectiveDate "dateMed" "" "" "null"}}',
                            },
                            { label: 'Navps', value: "{{format navps 'pctMax2' }}" },
                        ],
                        transformRowsData: false,
                        isCollapsible: false,
                        filterData: false,
                        functionToTransformRows: 'return (data) => {return data}',
                        rows: 'performance.prices.values',
                    },
                    contentPlaceHolders: {
                        children: [],
                        'top-children': ['a50bd0de-0cfe-469a-a2ae-96893b97a8d0'],
                        'bottom-children': ['ad16ce01-cd0e-44c5-a5ce-8112e842c8b8'],
                    },
                },
                'a50bd0de-0cfe-469a-a2ae-96893b97a8d0': {
                    id: 'a50bd0de-0cfe-469a-a2ae-96893b97a8d0',
                    widgetId: 'DownloadWithQuery',
                    parentId: '942a54a5-bddf-41aa-853b-bf5cb2f89c14',
                    properties: {
                        styles: '',
                        opacity: '',
                        blendMode: 'normal',
                        decoration: 'none',
                        fontFamily: '',
                        fontWeight: 'normal',
                        wordSpacing: '',
                        lineHeight: '',
                        textIndent: '',
                        color: '',
                        fontSize: '',
                        horizontalAlignment: '',
                        verticalAlignment: '',
                        shadow: '',
                        typographyClass: 'Default',
                        blendModeStyle: 'normal',
                        backgroundColor: '',
                        borderWidth: '',
                        borderColor: '',
                        borderStyle: 'unset',
                        borderRadius: '',
                        boxShadow: '',
                        width: '',
                        height: '',
                        margin: '',
                        padding: '',
                        display: '',
                        dataSourceType: 'GraphQL',
                        dataSource: 'mutual-funds-production',
                        query: 'query prices(\r\n        $profileId: String = "17478"\r\n        $locale: String = "en-US"\r\n  \t\t\t$effectiveDate: String = ""\r\n    ) {\r\n      \r\n      prices(entityId: $profileId,locale: $locale, effectiveDate: $effectiveDate) {\r\n        navps\r\n        effectiveDate\r\n      }\r\n    }\r\n\t',
                        queryVariables:
                            "return (data) => {\r\n  const urlParams = new URLSearchParams(data.search);\r\n  const profileId = urlParams.get('profileId');\r\n  const env =  urlParams.get('env') || 'prod';\r\n  \r\n  let locale = data.locale;\r\n\r\n  if (urlParams.get('locale')) {\r\n    locale = urlParams.get('locale');\r\n  }\r\n\r\n  return {\r\n    locale: locale || 'en-US',\r\n    profileId,\r\n    effectiveDate: '',\r\n  };\r\n};",
                        transformFunction:
                            'return (_data) => {\r\n    const {data} = _data;\r\n    return data.prices;\r\n}',
                        fileName: 'File',
                        buttonLabel: 'Download',
                        showButtonIcon: true,
                        showLoadingIcon: false,
                        showErrorMessage: false,
                        buttonIconPosition: 'Right',
                        buttonIconType: 'FontAwesome Icon',
                        buttonIconName: 'fa-solid fa-download',
                    },
                    contentPlaceHolders: { children: [] },
                },
                'ad16ce01-cd0e-44c5-a5ce-8112e842c8b8': {
                    id: 'ad16ce01-cd0e-44c5-a5ce-8112e842c8b8',
                    widgetId: 'DownloadWithQuery',
                    parentId: '942a54a5-bddf-41aa-853b-bf5cb2f89c14',
                    properties: {
                        styles: '',
                        opacity: '',
                        blendMode: 'normal',
                        decoration: 'none',
                        fontFamily: '',
                        fontWeight: 'normal',
                        wordSpacing: '',
                        lineHeight: '',
                        textIndent: '',
                        color: '',
                        fontSize: '',
                        horizontalAlignment: '',
                        verticalAlignment: '',
                        shadow: '',
                        typographyClass: 'Default',
                        blendModeStyle: 'normal',
                        backgroundColor: '',
                        borderWidth: '',
                        borderColor: '',
                        borderStyle: 'unset',
                        borderRadius: '',
                        boxShadow: '',
                        width: '',
                        height: '',
                        margin: '',
                        padding: '',
                        display: '',
                        dataSourceType: 'GraphQL',
                        dataSource: 'mutual-funds-production',
                        query: 'query prices(\r\n        $profileId: String = "17478"\r\n        $locale: String = "en-US"\r\n  \t\t\t$effectiveDate: String = ""\r\n    ) {\r\n      \r\n      prices(entityId: $profileId,locale: $locale, effectiveDate: $effectiveDate) {\r\n        navps\r\n        effectiveDate\r\n      }\r\n    }\r\n\t',
                        queryVariables:
                            "return (data) => {\r\n  const urlParams = new URLSearchParams(data.search);\r\n  const profileId = urlParams.get('profileId');\r\n  const env =  urlParams.get('env') || 'prod';\r\n  \r\n  let locale = data.locale;\r\n\r\n  if (urlParams.get('locale')) {\r\n    locale = urlParams.get('locale');\r\n  }\r\n\r\n  return {\r\n    locale: locale || 'en-US',\r\n    profileId,\r\n    effectiveDate: '',\r\n  };\r\n};",
                        transformFunction:
                            'return (_data) => {\r\n    const {data} = _data;\r\n    return data.prices;\r\n}',
                        fileName: 'file-1',
                        buttonLabel: 'Download',
                        showButtonIcon: true,
                        showLoadingIcon: true,
                        showErrorMessage: true,
                        buttonIconPosition: 'Right',
                        buttonIconType: 'FontAwesome Icon',
                        buttonIconName: 'fa-solid fa-download',
                        loadingIconPosition: 'Right',
                        loadingIconType: 'FontAwesome Icon',
                        loadingIconName: 'fa-circle-notch fa-spin fa-xs',
                        showErrorIcon: true,
                        errorIconPosition: 'Right',
                        errorIconType: 'FontAwesome Icon',
                        errorIconName: 'fa-exclamation-circle',
                    },
                    contentPlaceHolders: { children: [] },
                },
                '061fd219-614e-4184-8239-93d1f2d0ed1a': {
                    id: '061fd219-614e-4184-8239-93d1f2d0ed1a',
                    widgetId: 'Table',
                    parentId: 'root',
                    properties: {
                        styles: '',
                        opacity: '',
                        blendMode: 'normal',
                        decoration: 'none',
                        fontFamily: '',
                        fontWeight: 'normal',
                        wordSpacing: '',
                        lineHeight: '',
                        textIndent: '',
                        color: '',
                        fontSize: '',
                        horizontalAlignment: '',
                        verticalAlignment: '',
                        shadow: '',
                        blendModeStyle: 'normal',
                        backgroundColor: '',
                        borderWidth: '',
                        borderColor: '',
                        borderStyle: 'unset',
                        borderRadius: '',
                        boxShadow: '',
                        margin: '',
                        padding: '',
                        display: '',
                        columns: [
                            { label: 'Name', value: '{{ overview.fundName }}' },
                            {
                                linkText: '{{ webProfiles.relatedDocuments.0.name }}',
                                label: 'Document',
                                value: '{{ relatedDocuments.0.name}}',
                                isLink: true,
                                linkIcon: 'fas fa-file-pdf',
                                linkUrl: '{{ relatedDocuments.0.url}}',
                            },
                        ],
                        transformRowsData: false,
                        isCollapsible: false,
                        filterData: true,
                        filterBy: 'entityId',
                        filterWithUrlParam: true,
                        filterUrlParam: 'otherResource',
                        filterWith: '',
                        rows: 'webProfiles',
                    },
                    contentPlaceHolders: { children: [] },
                },
                '1be11f9d-4a0a-480f-bbee-eba6d0b7fc10': {
                    id: '1be11f9d-4a0a-480f-bbee-eba6d0b7fc10',
                    widgetId: 'ModalOnLoad',
                    parentId: 'root',
                    properties: {
                        styles: 'padding: 0.1in;',
                        opacity: '',
                        blendMode: 'normal',
                        decoration: 'none',
                        fontFamily: '',
                        fontWeight: 'normal',
                        wordSpacing: '',
                        lineHeight: '',
                        textIndent: '',
                        color: '',
                        fontSize: '',
                        horizontalAlignment: '',
                        verticalAlignment: '',
                        shadow: '',
                        typographyClass: 'Default',
                        blendModeStyle: 'normal',
                        backgroundColor: '',
                        borderWidth: '',
                        borderColor: '',
                        borderStyle: 'unset',
                        borderRadius: '',
                        boxShadow: '',
                        width: '',
                        height: '',
                        margin: '',
                        padding: '',
                        display: '',
                        closeButtonHtml: '<span>Close</span>',
                        acceptButtonText: 'Accept',
                        acceptButtonAriaLabel: 'Accept',
                        declineButtonText: 'Decline',
                        declineButtonAriaLabel: 'Decline',
                        rememberCheckboxLabel: 'Remember this selection',
                        storageName: 'ModalOnLoad',
                        itemToAddInStorage: 'entityId',
                        showModalInEditMode: true,
                        itemToAddOrRemoveFromFavorite: '{{entityId}}',
                        annotationTag: 'modal',
                        linkOnDecline:
                            'http://localhost:3000/test-page-lakshita?profileId={{entityId}}',
                        linkTarget: '_blank',
                    },
                    contentPlaceHolders: {
                        'bottom-modal': [],
                        'top-modal': [],
                    },
                },
                '097c609f-9cdf-4213-aa92-31289da74d2c': {
                    id: '097c609f-9cdf-4213-aa92-31289da74d2c',
                    widgetId: 'Page',
                    parentId: 'root',
                    properties: {
                        styles: '',
                        pageName: 'testPage',
                        pageSize: 'Custom',
                        pageOrientation: 'portrait',
                        pageMargin: { top: 0.4, left: 0.4, bottom: 0.4, right: 0.4 },
                        pageBleed: { top: 0, left: 0, bottom: 0, right: 0 },
                        overflowOption: 'noContinue',
                        includeHeader: true,
                        includeFooter: true,
                        pageWidth: 8.5,
                        pageHeight: 11,
                        isSource: true,
                        isTarget: false,
                        isRunningHeader: false,
                        isRunningFooter: false,
                        targetPageId: 'page2',
                        sourcePageName: 'page1',
                        chainFlowName: 'chain',
                    },
                    contentPlaceHolders: {
                        children: [],
                        'page-header': ['4e62bc7e-5db6-4230-981d-2a5a3bfe4aa2'],
                        'page-footer': ['aa860caa-9d1d-48d5-af2f-d543ed4645db'],
                        'page-children': ['62d6f571-190c-4d0d-8b3c-c3ef4a40f30d'],
                    },
                },
                '4e62bc7e-5db6-4230-981d-2a5a3bfe4aa2': {
                    id: '4e62bc7e-5db6-4230-981d-2a5a3bfe4aa2',
                    widgetId: 'Text',
                    parentId: '097c609f-9cdf-4213-aa92-31289da74d2c',
                    properties: {
                        styles: 'background: blue;',
                        opacity: '',
                        blendMode: 'normal',
                        decoration: 'none',
                        fontFamily: '',
                        fontWeight: 'normal',
                        wordSpacing: '',
                        lineHeight: '',
                        textIndent: '',
                        color: '',
                        fontSize: '',
                        horizontalAlignment: '',
                        verticalAlignment: '',
                        shadow: '',
                        typographyClass: 'Default',
                        blendModeStyle: 'normal',
                        backgroundColor: '',
                        borderWidth: '',
                        borderColor: '',
                        borderStyle: 'unset',
                        borderRadius: '',
                        boxShadow: '',
                        width: '',
                        height: '',
                        margin: '',
                        padding: '',
                        display: '',
                        textInput: 'Header',
                        isTransformData: false,
                    },
                    contentPlaceHolders: { children: [] },
                },
                'aa860caa-9d1d-48d5-af2f-d543ed4645db': {
                    id: 'aa860caa-9d1d-48d5-af2f-d543ed4645db',
                    widgetId: 'Text',
                    parentId: '097c609f-9cdf-4213-aa92-31289da74d2c',
                    properties: {
                        styles: 'background: grey;',
                        opacity: '',
                        blendMode: 'normal',
                        decoration: 'none',
                        fontFamily: '',
                        fontWeight: 'normal',
                        wordSpacing: '',
                        lineHeight: '',
                        textIndent: '',
                        color: '',
                        fontSize: '',
                        horizontalAlignment: '',
                        verticalAlignment: '',
                        shadow: '',
                        typographyClass: 'Default',
                        blendModeStyle: 'normal',
                        backgroundColor: '',
                        borderWidth: '',
                        borderColor: '',
                        borderStyle: 'unset',
                        borderRadius: '',
                        boxShadow: '',
                        width: '',
                        height: '',
                        margin: '',
                        padding: '',
                        display: '',
                        textInput: 'Footer',
                        isTransformData: false,
                    },
                    contentPlaceHolders: { children: [] },
                },
                '62d6f571-190c-4d0d-8b3c-c3ef4a40f30d': {
                    id: '62d6f571-190c-4d0d-8b3c-c3ef4a40f30d',
                    widgetId: 'Text',
                    parentId: '097c609f-9cdf-4213-aa92-31289da74d2c',
                    properties: {
                        styles: 'background: lightgrey;\r\n// width: 5in;',
                        opacity: '',
                        blendMode: 'normal',
                        decoration: 'none',
                        fontFamily: '',
                        fontWeight: 'normal',
                        wordSpacing: '',
                        lineHeight: '',
                        textIndent: '',
                        color: '',
                        fontSize: '',
                        horizontalAlignment: '',
                        verticalAlignment: '',
                        shadow: '',
                        typographyClass: 'Default',
                        blendModeStyle: 'normal',
                        backgroundColor: '',
                        borderWidth: '',
                        borderColor: '',
                        borderStyle: 'unset',
                        borderRadius: '',
                        boxShadow: '',
                        width: '',
                        height: '',
                        margin: '',
                        padding: '',
                        display: '',
                        textInput:
                            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam nec tellus vehicula, porttitor nisl vitae, fermentum elit. Phasellus eu mollis lacus. Quisque vel mi eget tortor iaculis porta. Sed sed ipsum purus.',
                        isTransformData: false,
                    },
                    contentPlaceHolders: { children: [] },
                },
                '677c609f-9cdf-4213-aa92-31289da74d2c': {
                    id: '677c609f-9cdf-4213-aa92-31289da74d2c',
                    widgetId: 'Page',
                    parentId: 'root',
                    properties: {
                        styles: '',
                        pageName: 'testPage',
                        pageSize: 'Custom',
                        pageOrientation: 'portrait',
                        pageMargin: { top: 0.4, left: 0.4, bottom: 0.4, right: 0.4 },
                        pageBleed: { top: 0, left: 0, bottom: 0, right: 0 },
                        overflowOption: 'hidden',
                        includeHeader: true,
                        includeFooter: true,
                        pageWidth: 8.5,
                        pageHeight: 11,
                    },
                    contentPlaceHolders: {
                        children: [],
                    },
                },
                '57m7df8f-9cdf-4213-aa92-31289da74d2c': {
                    id: '57m7df8f-9cdf-4213-aa92-31289da74d2c',
                    widgetId: 'Page',
                    parentId: 'root',
                    properties: {
                        styles: '',
                        pageName: 'testPage',
                        pageSize: 'Custom',
                        pageOrientation: 'portrait',
                        pageMargin: { top: 0.4, left: 0.4, bottom: 0.4, right: 0.4 },
                        pageBleed: { top: 0, left: 0, bottom: 0, right: 0 },
                        overflowOption: 'continue',
                        includeHeader: false,
                        includeFooter: false,
                        pageWidth: 8.5,
                        pageHeight: 11,
                        isSource: true,
                        isTarget: false,
                        chainFlowName: 'chain',
                    },
                    contentPlaceHolders: {
                        children: [],
                    },
                },
                '802c3532-900d-4fc6-9e31-dbfd13f702cd': {
                    id: '802c3532-900d-4fc6-9e31-dbfd13f702cd',
                    widgetId: 'CustomizedFundList',
                    parentId: 'root',
                    properties: {
                        styles: '',
                        opacity: '',
                        blendMode: 'normal',
                        decoration: 'none',
                        fontFamily: '',
                        fontWeight: 'normal',
                        wordSpacing: '',
                        lineHeight: '',
                        textIndent: '',
                        color: '',
                        fontSize: '',
                        horizontalAlignment: '',
                        verticalAlignment: '',
                        shadow: '',
                        typographyClass: 'Default',
                        blendModeStyle: 'normal',
                        backgroundColor: '',
                        borderWidth: '',
                        borderColor: '',
                        borderStyle: 'unset',
                        borderRadius: '',
                        boxShadow: '',
                        margin: '',
                        padding: '',
                        display: '',
                        columns: [
                            {
                                id: 'drName',
                                iconSort: 'fa-sort',
                                iconUp: 'fa-sort-up',
                                iconDown: 'fa-sort-down',
                                type: 'Watchlist',
                                watchlistType: 'icon',
                                watchlistIconName: 'far fa-star',
                                selectedWatchlistIconName: 'fas fa-star',
                                label: 'DR Name',
                                value: '{{ drName }}',
                                isSortable: true,
                                sortId: 'drName',
                                iconPosition: 'Left',
                                iconType: 'FontAwesome icon',
                            },
                            {
                                id: 'link',
                                label: 'link',
                                type: 'Placeholder',
                                placeholderId: 'ph',
                            },
                            {
                                id: 'drPrice',
                                label: 'DR Price',
                                columnGrouping: 'TopHeader',
                                type: 'Text value',
                                isSortable: true,
                                value: '{{ drPrice }}',
                                sortId: 'drPrice',
                                iconPosition: 'Right',
                                iconType: 'Image',
                                imageSort: '/assets/static/images/arrow-up-down.png',
                                imageUp: '/assets/static/images/arrow-up.png',
                                imageDown: '/assets/static/images/arrow-down.png',
                            },
                            {
                                id: 'compare',
                                label: 'Compare',
                                columnGrouping: 'TopHeader',
                                labelDescription: '(Up to 10)',
                                type: 'Selection',
                                isSortable: false,
                                selectionListId: 'id',
                                selectionUsedFor: 'compare',
                                selectionListStorageName: 'compare',
                                changeToTab: 'performance',
                                maxSelectionCount: 10,
                                sortId: 'drPrice',
                                iconPosition: 'Right',
                                iconType: 'Image',
                                imageSort: '/assets/static/images/arrow-up-down.png',
                                imageUp: '/assets/static/images/arrow-up.png',
                                imageDown: '/assets/static/images/arrow-down.png',
                                ActiveButtonText: 'view all',
                            },
                        ],
                        rows: 'listData',
                        enableWatchlist: true,
                        watchlistStorageName: 'watchlist',
                        watchlistDataId: 'id',
                        watchlistButtonText: 'WATCH LIST',
                        showAllFundsBtnText: 'Show all Funds',
                        addToWatchlistText: '',
                        removeFromWatchlistText: '',
                        showPageSizePicker: true,
                        enablePagination: true,
                        configurePageSizes: '10,20,50,100',
                        showCurrentPageText: true,
                        pagingType: 'simple_numbers',
                        defaultPageSize: 10,
                        pagePickerPosition: 'right',
                        pageSizePickerPosition: 'left',
                        currentPageTextPosition: 'left',
                        pagerButtonStyle: 'circle',
                        currentPageText: '',
                        previousBtnText: '',
                        nextBtnText: '',
                        firstBtnText: '',
                        lastBtnText: '',
                        pageSizePickerText: '',
                        pagePickerDropdownImage: '',
                        enableGrouping: true,
                        groupingPropertyId: 'drTicker',
                        showGroupingCount: true,
                        isCollapseRowGroup: false,
                        showRowGroupIconName: '',
                        hideRowGroupIconName: '',
                        defaultSortingOrder: 'descending',
                        filters: [
                            {
                                showSearchIcon: true,
                                searchIconPosition: 'Left',
                                searchIconType: 'FontAwesome Icon',
                                label: 'DR Name',
                                placeholder: 'e.g BMO DR',
                                type: 'Text',
                                filterBy: 'drName',
                                searchIcon: 'fa-search',
                                urlParam: 'drName',
                            },
                            {
                                dropdownIconType: 'FontAwesome Icon',
                                dropdownIconPosition: 'Right',
                                dropdownType: 'Multi Select',
                                dropdownItemSelectIconPosition: 'Right',
                                dropdownItemSelectIconType: 'FontAwesome Icon',
                                includeAllOption: true,
                                type: 'Dropdown',
                                label: 'Ticker',
                                placeholder: 'Select ticker',
                                filterBy: 'drTicker',
                                dropdownOpenIcon: 'fa-chevron-down',
                                dropdownCloseIcon: 'fa-chevron-up',
                                dropdownDataKey: 'sampleData.listData[*].drTicker',
                                urlParam: 'drTicker',
                                enableDDSearch: true,
                                noOptionFoundText: 'No Option Found',
                                searchDDIcon: 'fa-search',
                                searchDDIconType: 'FontAwesome Icon',
                                searchPlaceholder: 'Search',
                                serachDDIconPosition: 'Right',
                                showDDSearchIcon: true,
                            },
                            {
                                dropdownIconType: 'FontAwesome Icon',
                                dropdownIconPosition: 'Right',
                                dropdownType: 'Single Select',
                                includeAllOption: true,
                                dropdownItemSelectIconPosition: 'Right',
                                dropdownItemSelectIconType: 'FontAwesome Icon',
                                showSearchIcon: false,
                                type: 'Dropdown',
                                label: 'Country',
                                placeholder: 'Select',
                                filterBy: 'country',
                                dropdownDataKey: 'sampleData.listData[*].country',
                                dropdownItemSelectIcon: '',
                                dropdownOpenIcon: 'fa-chevron-down',
                                dropdownCloseIcon: 'fa-chevron-up',
                                urlParam: 'country',
                            },
                            {
                                datePickerIconPosition: 'Right',
                                datePickerIconType: 'FontAwesome Icon',
                                dateFormat: 'MMMM d, yyyy',
                                startDatelabel: 'Start date',
                                endDatelabel: 'End date',
                                datePickerIcon: 'fa-calendar',
                                type: 'Date range picker',
                                dataKey: 'sampleData.listData.date',
                                filterBy: 'date',
                                startDateErrorMessage: 'From date should be before to date',
                                endDateErrorMessage:
                                    'To date should be cannot be earlier than From date',
                                errorIconPosition: 'Right',
                                errorIconType: 'FontAwesome Icon',
                                errorIcon: 'fa-exclamation-circle',
                            },
                        ],
                        filtersUI: {
                            showSelectedFilters: true,
                            isCollapsible: true,
                            collapsibleIconPosition: 'Left',
                            collapsibleIconType: 'FontAwesome Icon',
                            collapsibleShowIcon: 'fa-chevron-down',
                            collapsibleHideIcon: 'fa-chevron-up',
                            collapsibleTextPosition: 'Right',
                            selectedFiltersCollapsible: true,
                            filterLabel: 'Filters',
                            clearAllText: 'Clear All',
                            appliedText: 'applied',
                            resultText: 'found',
                            showCollapsibleIcon: true,
                            showCollapsibleText: true,
                            collapsibleShowText: 'Hide',
                            collapsibleHideText: 'Show',
                        },
                        enableDownload: true,
                        downloadButtonText: 'Download As Csv',
                        downloadFileName: 'download',
                        downloadFileType: '.csv',
                        downloadFileTabName: 'download',
                        isAddPlaceholderInLeftPanelOfTableCtrls: true,
                        isAddPlaceholderInRightPanelOfTableCtrls: true,
                        addPlaceholderWhenNoData: true,
                        tabs: [
                            {
                                tabColumns: 'drName,link,drPrice,compare',
                                id: 'overview',
                                name: 'Overview',
                                isDefaultSelected: true,
                            },
                            {
                                tabColumns: 'drName,drPrice,compare',
                                id: 'performance',
                                name: 'Performance',
                            },
                        ],
                        columnGroups: [{ id: 'TopHeader', label: 'Top Header' }],
                    },
                    contentPlaceHolders: {
                        children: [],
                        'tableCntrls-rightPanel': [],
                        'tableCntrls-leftPanel': ['f28fec80-17f6-4d7e-9fbf-3f46c4af7348'],
                        'children-modal': [],
                        'tableCntrls-nodataplaceholder': [],
                        'children-s': [],
                        'children-sd': [],
                        'children-{{p6mo}}': [],
                    },
                },
                'f28fec80-17f6-4d7e-9fbf-3f46c4af7348': {
                    id: 'f28fec80-17f6-4d7e-9fbf-3f46c4af7348',
                    widgetId: 'DownloadWithQuery',
                    parentId: '802c3532-900d-4fc6-9e31-dbfd13f702cd',
                    properties: {
                        styles: '',
                        opacity: '',
                        blendMode: 'normal',
                        decoration: 'none',
                        fontFamily: '',
                        fontWeight: 'normal',
                        wordSpacing: '',
                        lineHeight: '',
                        textIndent: '',
                        color: '',
                        fontSize: '',
                        horizontalAlignment: '',
                        verticalAlignment: '',
                        shadow: '',
                        typographyClass: 'Default',
                        blendModeStyle: 'normal',
                        backgroundColor: '',
                        borderWidth: '',
                        borderColor: '',
                        borderStyle: 'unset',
                        borderRadius: '',
                        boxShadow: '',
                        width: '',
                        height: '',
                        margin: '',
                        padding: '',
                        display: '',
                        dataSourceType: 'GraphQL',
                        dataSource: 'mutual-funds-production',
                        query: '',
                        queryVariables: '',
                        transform: '',
                        transformFunction:
                            'return (_data) => {\r\n    const {data} = _data;\r\n    return data.webProfiles;\r\n};\r\n',
                        fileName: '',
                        buttonLabel: 'Download',
                        showButtonIcon: true,
                        showLoadingIcon: true,
                        showErrorMessage: true,
                        buttonIconPosition: 'Left',
                        buttonIconType: 'FontAwesome Icon',
                        buttonIconName: 'fa-solid fa-download',
                        loadingIconPosition: 'Left',
                        loadingIconType: 'FontAwesome Icon',
                        loadingIconName: 'fa-circle-notch fa-spin fa-xs',
                        showErrorIcon: true,
                        errorIconPosition: 'Right',
                        errorIconType: 'FontAwesome Icon',
                        errorIconName: 'fa-exclamation-circle',
                    },
                    contentPlaceHolders: { children: [] },
                },
            },
            id: '/clients/fc7c66b2-38f2-414c-939b-24d5830e9657/app-data/tm/production/pages/sample-page',
            etag: 'id3vnUgCoeoxwijAGtx+Yw==',
        },
        documentMetadata: {
            locale: 'en-US',
        },
        bottomBarTabs: ['Style', 'Data'],
    },
    themes: {
        isThemeLoaded: false,
        themeLoading: false,
        themeLoadError: null,
        themeSaveLoading: false,
        themeSaveSucess: '',
        themeSaveError: null,
        themes: null,
        themesLoading: false,
        themesLoadError: null,
        selectedThemes: [],
        versions: null,
        versionsLoading: false,
        versionsLoadError: null,
        revertedVersion: false,
        revertedVersionError: null,
        colorPalettes: null,
        showDeletedItems: false,
        newFolderSaveLoading: false,
        newFolderSaveError: null,
        newFolderSaveSucess: '',
        theme: {
            userTypography: {},
            colors: {
                hex: '#ec0909',
                rgb: 'rgb(236,9,9)',
                cmyk: 'cmyk(7.4509803921568585%,96.47058823529412%,96.47058823529412%,7.4509803921568585%)',
                spot: 'null',
            },
            defaultColors: {
                hex: '#ffffff',
                rgb: 'rgb(255, 255, 255)',
                cmyk: 'cmyk(0%, 0%, 0%, 0%)',
                spot: '',
            },
            typography: {
                '--heading-level-one': {
                    fontFamily: 'OpenSans-Regular',
                    fontSize: '32px',
                    fontWeight: '700',
                    letterSpacing: '',
                    wordSpacing: '',
                    lineHeight: '40px',
                },
                '--heading-level-two': {
                    fontFamily: 'OpenSans-Regular',
                    fontSize: '28px',
                    fontWeight: '700',
                    letterSpacing: '',
                    wordSpacing: '',
                    lineHeight: '32px',
                },
                '--heading-level-three': {
                    fontFamily: 'OpenSans-Regular',
                    fontSize: '24px',
                    fontWeight: '700',
                    letterSpacing: '',
                    wordSpacing: '',
                    lineHeight: '28px',
                },
                '--heading-level-four': {
                    fontFamily: 'OpenSans-Regular',
                    fontSize: '20px',
                    fontWeight: '700',
                    letterSpacing: '',
                    wordSpacing: '',
                    lineHeight: '28px',
                },
                '--heading-level-five': {
                    fontFamily: 'OpenSans-Regular',
                    fontSize: '16px',
                    fontWeight: '700',
                    letterSpacing: '',
                    wordSpacing: '',
                    lineHeight: '24px',
                },
                '--heading-level-six': {
                    fontFamily: 'OpenSans-Regular',
                    fontSize: '14px',
                    fontWeight: '700',
                    letterSpacing: '',
                    wordSpacing: '',
                    lineHeight: '24px',
                },
                '--section-title': {
                    fontFamily: 'OpenSans-Regular',
                    fontSize: '16px',
                    fontWeight: '500',
                    letterSpacing: '',
                    wordSpacing: '',
                    lineHeight: '28px',
                },
                '--section-sub-title': {
                    fontFamily: 'OpenSans-Regular',
                    fontSize: '14px',
                    fontWeight: '500',
                    letterSpacing: '',
                    wordSpacing: '',
                    lineHeight: '24px',
                },
                '--body-large': {
                    fontFamily: 'OpenSans-Regular',
                    fontSize: '16px',
                    fontWeight: '400',
                    letterSpacing: '',
                    wordSpacing: '',
                    lineHeight: '28px',
                },
                '--body': {
                    fontFamily: 'OpenSans-Regular',
                    fontSize: '14px',
                    fontWeight: '400',
                    letterSpacing: '',
                    wordSpacing: '',
                    lineHeight: '24px',
                },
                '--body-small': {
                    fontFamily: 'OpenSans-Regular',
                    fontSize: '12px',
                    fontWeight: '400',
                    letterSpacing: '',
                    wordSpacing: '',
                    lineHeight: '20px',
                },
            },
            defaultFonts: [
                {
                    format: 'truetype',
                    fontWeight: '400',
                    fontStyle: 'normal',
                    fontDisplay: 'normal',
                    name: 'OpenSans-Regular',
                    src: '../../assets/fonts/OpenSans-Regular.ttf',
                },
                {
                    format: 'truetype',
                    fontWeight: '300',
                    fontStyle: 'normal',
                    fontDisplay: 'normal',
                    name: 'OpenSans-Light',
                    src: '../../assets/fonts/OpenSans-Light.ttf',
                },
                {
                    format: 'truetype',
                    fontWeight: '500',
                    fontStyle: 'normal',
                    fontDisplay: 'normal',
                    name: 'OpenSans-Medium',
                    src: '../../assets/fonts/OpenSans-Medium.ttf',
                },
                {
                    format: 'truetype',
                    fontWeight: '600',
                    fontStyle: 'normal',
                    fontDisplay: 'normal',
                    name: 'OpenSans-SemiBold',
                    src: '../../assets/fonts/OpenSans-SemiBold.ttf',
                },
                {
                    format: 'truetype',
                    fontWeight: '700',
                    fontStyle: 'normal',
                    fontDisplay: 'normal',
                    name: 'OpenSans-Bold',
                    src: '../../assets/fonts/OpenSans-Bold.ttf',
                },
                {
                    format: 'truetype',
                    fontWeight: '900',
                    fontStyle: 'normal',
                    fontDisplay: 'normal',
                    name: 'OpenSans-ExtraBold',
                    src: '../../assets/fonts/OpenSans-ExtraBold.ttf',
                },
            ],
            userFonts: [],
            componentThemes: {
                linkComponent: {
                    fontSize: '14px',
                    fontWeight: '400',
                    lineHeight: '24px',
                    textColor: '#0000EE',
                    activeTextColor: '#FF0000',
                    activeBorderColor: '#FF0000',
                    hoverTextColor: '#808080',
                    visitedTextColor: '#FFC0CB',
                    activeBorderWidth: '0px 0px 1px 0px',
                    activeBorderStyle: 'solid',
                    textDecoration: 'none',
                    fontFamily: 'OpenSans-Regular',
                },
                buttonComponent: {
                    fontSize: '14px',
                    fontWeight: 'normal',
                    lineHeight: '24px',
                    textColor: '#ffffff',
                    primaryBorderColor: '#116fa5',
                    primaryBackgroundColor: '#116fa5',
                    disabledBorderColor: '#9aabb5',
                    disabledBackgroundColor: '#9aabb5',
                    deleteBorderColor: '#FF4742',
                    deleteBackGroundColor: '#FF4742',
                    okBorderColor: '#00FF00',
                    okBackGroundColor: '#00FF00',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    padding: '4px 8px 4px 8px',
                    borderRadius: '4px',
                    fontFamily: 'OpenSans-Regular',
                },
                tableComponent: {
                    thFontSize: '14px',
                    thFontWeight: '700',
                    thLineHeight: '24px',
                    thTextColor: '#000000',
                    thBorderWidth: '0px 0px 1px 0px',
                    thBorderStyle: 'solid',
                    thBorderColor: '#E0E0E0',
                    thPadding: '8px',
                    tdFontSize: '14px',
                    tdFontWeight: '400',
                    tdLineHeight: '24px',
                    tdTextColor: '#000000',
                    tdBorderWidth: '0px 0px 1px 0px',
                    tdBorderStyle: 'solid',
                    tdBorderColor: '#E0E0E0',
                    tdPadding: '8px',
                    alternatedRowsBGColor: '#E0E0E0',
                    tableWidth: '100%',
                    thFontFamily: 'OpenSans-Regular',
                    tdFontFamily: 'OpenSans-Regular',
                },
                listComponent: {
                    listPadding: '0px 0px 0px 0px',
                    listItemPadding: '4px 0px 4px 0px',
                    listItemFontSize: '14px',
                    listItemFontWeight: '400',
                    listItemLineHeight: '24px',
                    listItemTextColor: '#000000',
                    listItemBorderWidth: '0px 0px 1px 0px',
                    listItemBorderStyle: 'solid',
                    listItemBorderColor: '#E0E0E0',
                    listKeyFontWeight: '700',
                    listKeyFontSize: '14px',
                    listKeyTextColor: '#000000',
                    listValueFontWeight: '400',
                    listValueFontSize: '14px',
                    listValueTextColor: '#000000',
                    alternateListItemsBgColor: '#E0E0E0',
                    listItemFontFamily: 'OpenSans-Regular',
                    listKeyFontFamily: 'OpenSans-Regular',
                    listValueFontFamily: 'OpenSans-Regular',
                },
            },
            defaultPalettes: {
                pieChartPalette: {
                    '10': {
                        hex: '#8877ab',
                        rgb: 'rgb(136,119,171)',
                        cmyk: 'cmyk(46.666666666666664%,53.333333333333336%,32.94117647058824%,32.94117647058824%)',
                        spot: 'null',
                    },
                    '11': {
                        hex: '#fcc457',
                        rgb: 'rgb(252,196,87)',
                        cmyk: 'cmyk(1.17647058823529%,23.13725490196078%,65.88235294117646%,1.17647058823529%)',
                        spot: 'null',
                    },
                    '01': {
                        hex: '#00a758',
                        rgb: 'rgb(0,167,88)',
                        cmyk: 'cmyk(100%,34.509803921568626%,65.49019607843137%,34.509803921568626%)',
                        spot: 'null',
                    },
                    '02': {
                        hex: '#0000c1',
                        rgb: 'rgb(0,0,193)',
                        cmyk: 'cmyk(100%,100%,24.31372549019608%,24.31372549019608%)',
                        spot: 'null',
                    },
                    '03': {
                        hex: '#ec6453',
                        rgb: 'rgb(236,100,83)',
                        cmyk: 'cmyk(7.4509803921568585%,60.7843137254902%,67.45098039215686%,7.4509803921568585%)',
                        spot: 'null',
                    },
                    '04': {
                        hex: '#260b42',
                        rgb: 'rgb(38,11,66)',
                        cmyk: 'cmyk(85.09803921568627%,95.68627450980392%,74.11764705882354%,74.11764705882354%)',
                        spot: 'null',
                    },
                    '05': {
                        hex: '#ce7612',
                        rgb: 'rgb(206,118,18)',
                        cmyk: 'cmyk(19.215686274509803%,53.72549019607843%,92.94117647058823%,19.215686274509803%)',
                        spot: 'null',
                    },
                    '06': {
                        hex: '#08a298',
                        rgb: 'rgb(8,162,152)',
                        cmyk: 'cmyk(96.86274509803921%,36.47058823529412%,40.3921568627451%,36.47058823529412%)',
                        spot: 'null',
                    },
                    '07': {
                        hex: '#c14836',
                        rgb: 'rgb(193,72,54)',
                        cmyk: 'cmyk(24.31372549019608%,71.76470588235294%,78.82352941176471%,24.31372549019608%)',
                        spot: 'null',
                    },
                    '08': {
                        hex: '#2d69ff',
                        rgb: 'rgb(45,105,255)',
                        cmyk: 'cmyk(82.35294117647058%,58.82352941176471%,0%,0%)',
                        spot: 'null',
                    },
                    '09': {
                        hex: '#004427',
                        rgb: 'rgb(0,68,39)',
                        cmyk: 'cmyk(100%,73.33333333333334%,84.70588235294117%,73.33333333333334%)',
                        spot: 'null',
                    },
                },
                barChartPalette: {
                    '10': {
                        hex: '#0c20bb',
                        rgb: 'rgb(12,32,187)',
                        cmyk: 'cmyk(95.29411764705881%,87.45098039215686%,26.66666666666667%,26.66666666666667%)',
                        spot: 'null',
                    },
                    '11': {
                        hex: '#13ae7b',
                        rgb: 'rgb(19,174,123)',
                        cmyk: 'cmyk(92.54901960784314%,31.76470588235294%,51.764705882352935%,31.76470588235294%)',
                        spot: 'null',
                    },
                    '01': {
                        hex: '#a62dae',
                        rgb: 'rgb(166,45,174)',
                        cmyk: 'cmyk(34.90196078431372%,82.35294117647058%,31.76470588235294%,31.76470588235294%)',
                        spot: 'null',
                    },
                    '02': {
                        hex: '#1fbbdb',
                        rgb: 'rgb(31,187,219)',
                        cmyk: 'cmyk(87.84313725490196%,26.66666666666667%,14.117647058823534%,14.117647058823534%)',
                        spot: 'null',
                    },
                    '03': {
                        hex: '#df210c',
                        rgb: 'rgb(223,33,12)',
                        cmyk: 'cmyk(12.549019607843137%,87.05882352941177%,95.29411764705881%,12.549019607843137%)',
                        spot: 'null',
                    },
                    '04': {
                        hex: '#e10505',
                        rgb: 'rgb(225,5,5)',
                        cmyk: 'cmyk(11.764705882352944%,98.0392156862745%,98.0392156862745%,11.764705882352944%)',
                        spot: 'null',
                    },
                    '05': {
                        hex: '#ce7612',
                        rgb: 'rgb(206,118,18)',
                        cmyk: 'cmyk(19.215686274509803%,53.72549019607843%,92.94117647058823%,19.215686274509803%)',
                        spot: 'null',
                    },
                    '06': {
                        hex: '#cde802',
                        rgb: 'rgb(205,232,2)',
                        cmyk: 'cmyk(19.6078431372549%,9.019607843137257%,99.2156862745098%,9.019607843137257%)',
                        spot: 'null',
                    },
                    '07': {
                        hex: '#d68a9d',
                        rgb: 'rgb(214,138,157)',
                        cmyk: 'cmyk(16.07843137254902%,45.88235294117647%,38.431372549019606%,16.07843137254902%)',
                        spot: 'null',
                    },
                    '08': {
                        hex: '#e5a02a',
                        rgb: 'rgb(229,160,42)',
                        cmyk: 'cmyk(10.196078431372547%,37.254901960784316%,83.52941176470588%,10.196078431372547%)',
                        spot: 'null',
                    },
                    '09': {
                        hex: '#004427',
                        rgb: 'rgb(0,68,39)',
                        cmyk: 'cmyk(100%,73.33333333333334%,84.70588235294117%,73.33333333333334%)',
                        spot: 'null',
                    },
                },
            },
            palettes: {},
        },
    },
    users: {
        users: [
            {
                Id: '3f08410d-9a84-4531-a2d2-c881f4c56573',
                ClientId: 'fc7c66b2-38f2-414c-939b-24d5830e9657',
                Email: 'peter@transmissionmedia.ca',
                FirstName: '',
                LastName: '',
                Timestamp: 0,
            },
        ],
        isUsersLoading: false,
        isUsersLoaded: false,
        UserLoadedError: false,
    },
    adminUI: {
        pageNavSelectedOpt: {
            name: '',
            icon: '',
            activeIcon: '',
            component: null,
            showOnSecondLeftSidebar: true,
        },
    },
    adminPages: {
        items: null,
        itemsLoading: false,
        itemsLoadError: null,
        templates: null,
        templatesLoading: false,
        templatesLoadError: null,
        itemVersions: null,
        itemVersionsLoading: false,
        revertedVersion: false,
        itemVersionsLoadError: null,
        revertedVersionError: null,
        selectedPages: [],
        showDeletedItems: false,
    },
    envDiff: {
        listLoadError: null,
        listLoading: false,
        diffLoadError: null,
        diffLoading: false,
        mergingMessage: '',
        isMergeSuccessful: false,
        listItems: [
            { id: 'stg', path: 'prod', hostnames: [] },
            { id: 'dev', path: 'dev', hostnames: [] },
            { id: 'prod', path: 'prod', hostnames: [] },
        ],
        sourceEnv: 'dev',
        destEnv: 'prod',
        diffItems: [
            {
                key: '/assets',
                isFolder: true,
                isDifferent: true,
                src: {
                    versionNumber: 2,
                    author: '1ab69ff5-e4e1-43b1-88e0-accdd8a00cd3',
                    lastModifiedDate: '2023-03-22T16:00:54.165Z',
                    etag: '"gsyhckoMjZKj9A/Z6/r7Nw=="',
                },
                dest: {
                    versionNumber: 6,
                    author: '1ab69ff5-e4e1-43b1-88e0-accdd8a00cd3',
                    lastModifiedDate: '2023-01-17T17:16:37.579Z',
                    etag: '"Fr20SRJvyFZU99KTx3sBJQ=="',
                },
            },
            {
                key: '/resources',
                isFolder: false,
                isDifferent: true,
                src: {
                    versionNumber: 2,
                    author: '1ab69ff5-e4e1-43b1-88e0-accdd8a00cd3',
                    lastModifiedDate: '2023-03-22T16:00:54.165Z',
                    etag: '"gsyhckoMjZKj9A/Z6/r7Nw=="',
                },
                dest: {
                    versionNumber: 6,
                    author: '1ab69ff5-e4e1-43b1-88e0-accdd8a00cd3',
                    lastModifiedDate: '2023-01-17T17:16:37.579Z',
                    etag: '"Fr20SRJvyFZU99KTx3sBJQ=="',
                },
            },
            {
                key: '/font',
                isFolder: false,
                isDifferent: true,
                dest: {
                    versionNumber: 6,
                    author: '1ab69ff5-e4e1-43b1-88e0-accdd8a00cd3',
                    lastModifiedDate: '2023-01-17T17:16:37.579Z',
                    etag: '"Fr20SRJvyFZU99KTx3sBJQ=="',
                },
                src: {
                    versionNumber: 2,
                    author: '1ab69ff5-e4e1-43b1-88e0-accdd8a00cd3',
                    lastModifiedDate: '2023-03-22T16:00:54.165Z',
                    etag: '"gsyhckoMjZKj9A/Z6/r7Nw=="',
                },
            },
            {
                key: '/page',
                isFolder: false,
                isDifferent: true,
                src: {
                    versionNumber: 2,
                    author: '1ab69ff5-e4e1-43b1-88e0-accdd8a00cd3',
                    lastModifiedDate: '2023-03-22T16:00:54.165Z',
                    etag: '"gsyhckoMjZKj9A/Z6/r7Nw=="',
                },
                dest: {
                    versionNumber: 6,
                    author: '1ab69ff5-e4e1-43b1-88e0-accdd8a00cd3',
                    lastModifiedDate: '2023-01-17T17:16:37.579Z',
                    etag: '"Fr20SRJvyFZU99KTx3sBJQ=="',
                },
            },
            {
                key: '/assets/fonts',
                isFolder: true,
                isDifferent: true,
                src: {
                    versionNumber: 1,
                    author: 'bd29db21-0908-4a58-a66b-7ae15e984e62',
                    lastModifiedDate: '2023-04-05T18:28:31.698Z',
                    etag: '"Dti79vc+PPd+cSNvasKSrw=="',
                },
                dest: {
                    versionNumber: 2,
                    author: '1ab69ff5-e4e1-43b1-88e0-accdd8a00cd3',
                    lastModifiedDate: '2023-01-17T17:16:37.579Z',
                    etag: '"yp8urdzpEF1YGAc3ISDQJQ=="',
                },
            },
            {
                key: '/components/component-folder',
                isFolder: true,
                isDifferent: true,
                src: {
                    versionNumber: 1,
                    author: 'ac309ebf-8eae-48df-bbae-67c451fb6883',
                    lastModifiedDate: '2022-12-20T15:57:06.231Z',
                    etag: '"q8QzwDVEAcPuEI1HEIFYdw=="',
                },
                dest: {
                    versionNumber: 1,
                    author: 'ac309ebf-8eae-48df-bbae-67c451fb6883',
                    lastModifiedDate: '2022-12-20T15:57:06.231Z',
                    etag: '"q8QzwDVEAcPuEI1HEIFYdw=="',
                },
            },
            {
                key: '/components/public/annual-distributions-table',
                isFolder: false,
                isDifferent: true,
                src: {
                    versionNumber: 13,
                    author: 'bd29db21-0908-4a58-a66b-7ae15e984e62',
                    lastModifiedDate: '2023-03-24T17:02:18.547Z',
                    etag: '"7de1875235f3b5b21199ada57a071b42"',
                },
                dest: {
                    versionNumber: 13,
                    author: 'bd29db21-0908-4a58-a66b-7ae15e984e62',
                    lastModifiedDate: '2023-03-24T17:02:18.547Z',
                    etag: '"7de1875235f3b5b21199ada57a071b42"',
                },
            },
        ],
    },
};

const testAnnotations = {
    items: [
        {
            id: 'Growth10k-Performance',
            text: 'The “Growth of $10,000 invested” chart shows the final value of a hypothetical $10,000 investment in securities in this class/series of the fund without any withdrawal as at the end of the investment period indicated. This compound growth chart is for illustrative purposes only and is not intended to reflect future values or returns on investment in such securities.',
            textTargetId: undefined,
            markerTargetId: undefined,
            marker: undefined,
            sortOrder: 14,
            _id: 'Performance',
        },
        {
            id: 'aum',
            text: 'All classes/series combined. Assets as at {{ format overview.aumDate "dateLong" }}.',
            textTargetId: undefined,
            markerTargetId: 'aumLabel',
            marker: undefined,
            sortOrder: 14,
            _id: 'aum',
        },
        {
            id: 'averagecreditquality',
            text: "The average credit quality (ACQ) rating may change over time. The portfolio itself has not been rated by an independent rating agency. The fund’s underlying investments (except for unrated assets) are rated by designated rating organizations. The ratings generally range from AAA (highest) to D (lowest). Unrated bonds, cash and equivalents are not assigned ratings, and are not included in the ACQ. ACQ does not necessarily reflect the credit and default risks of individual holdings and its potential impact on an overall portfolio. The risk of default increases as a bond's rating decreases, so the ACQ provided is not a statistical measurement of the portfolio's default risk because a simple, weighted average does not measure the increasing level of risk from lower-rated bonds. The ACQ may be lower if cash and equivalents are excluded from the calculation. The ACQ is provided for informational purposes only. Derivative positions are not reflected in the ACQ.",
            textTargetId: undefined,
            markerTargetId: 'avgCreditQualitylabel',
            marker: undefined,
            sortOrder: 14,
            _id: 'averagecreditquality',
        },
        {
            id: 'distributionFrequency',
            text: 'The payment of distributions is not guaranteed and may fluctuate. If distributions paid by the fund are greater than the performance of the fund, then your original investment will shrink. Distributions should not be confused with a fund’s performance, rate of return, or yield. You may also receive return of capital distributions from a fund. Please consult with your tax advisor regarding the tax implications of receiving distributions. See the fund facts as well as the prospectus for more information on a fund’s distributions policy.',
            textTargetId: undefined,
            markerTargetId: 'distributionFrequencyLabel',
            marker: undefined,
            sortOrder: 14,
            _id: 'distributionFrequency',
        },
        {
            id: 'distributionYield',
            text: 'Distribution yield is calculated based on prior 12-month rolling average of paid distributions and using average month-end net asset value, per security. The distribution yield excludes any year-end capital gains distributions paid. Distribution yield should not be confused with a fund’s performance or rate of return.',
            textTargetId: undefined,
            markerTargetId: 'distributionYieldLabel',
            marker: undefined,
            sortOrder: 14,
            _id: 'distributionYield',
        },
        {
            id: 'dsc-fundcode-disclaimer',
            text: 'DSC/LL2/LL3 load options are available for switches only and are not available for new purchases.',
            textTargetId: undefined,
            markerTargetId: 'fundTable',
            marker: undefined,
            sortOrder: 14,
            _id: 'disclaimer',
        },
        {
            id: 'equityStyleBoxDisclaimer',
            text: 'The Equity style box information is determined by Morningstar Research Inc., an independent research firm. Morningstar information contained herein is proprietary to Morningstar and is not warranted to be accurate, complete or timely. Neither Morningstar nor its content providers are responsible for any damages or losses arising from any use of this information. © 2021 Morningstar Research Inc.',
            textTargetId: undefined,
            markerTargetId: 'equityStyleBox',
            marker: undefined,
            sortOrder: 14,
            _id: 'equityStyleBoxDisclaimer',
        },
        {
            id: 'growth10k',
            text: 'The rate of return shown is used only to illustrate the effects of the compound growth rate and is not intended to reflect future values or returns on investment.',
            textTargetId: undefined,
            markerTargetId: 'growthLabel',
            marker: undefined,
            sortOrder: 14,
            _id: 'growth10k',
        },
    ],
    markerCount: 0,
    annotationsIds: [],
    formats: {
        marker: '<a id="{markerId}" class="ann-marker" href="/admin/pages/test-page#{textId}">{marker}</a>',
        text: '<li id="{textId}"><sup><a class="ann-marker" href="/admin/pages/test-page#{markerId}">{marker}</a></sup>&nbsp;{text}</li>',
        textGroup: '<ul class="ann-list">{items}</ul>',
    },
    markerGroupCount: {},
};

const rootReducer = combineReducers({
    // Add reducers here when needed
    dummy: (state = {}) => state, // Temporary reducer
});

export function createTestStore(initialState?: any) {
    const store = configureStore({
        reducer: rootReducer,
        preloadedState: { ...preloadedState, ...initialState },
    });
    return store;
}

export function createTestContext(contextOverride?: Partial<AppContextShape>): AppContextShape {
    return {
        ...defaultAppContext,
        isClient: false,
        data: null,
        pageName: null,
        componentName: null,
        document: preloadedState.templateEditor?.document || null,
        documentType: (preloadedState.app?.documentType || 'web') as 'web' | 'pdf' | 'pptx',
        colorPalettes: null,
        documentMetadata: preloadedState.templateEditor
            ?.documentMetadata as coreTypes.MetaDataOptions,
        inEditMode: false,
        theme: preloadedState.themes?.theme || null,
        themeSelected: '',
        fundList: {
            selectedList: [],
        },
        annotations: testAnnotations || defaultAnnotations,
        annotator: new Annotator(testAnnotations || defaultAnnotations),
        queries: {},
        setters: {
            setSelectedList: () => {},
            setAnnotations: () => {},
            setQueries: () => {},
        },
        originalHostname: preloadedState.app?.originalHostname || '',
        baseUrl: preloadedState.app?.baseUrl || '/',
        url: preloadedState.app?.url || '',
        ...contextOverride,
    };
}
